import { MdDeleteOutline } from 'react-icons/md';
import styled from 'styled-components';

import { colors, radii } from '@gbs-monorepo-packages/styles';

import { FileIcon } from '../FileIcon';

export const Container = styled.div`
  width: 100%;
`;

export const DropzoneBox = styled.div`
  width: 100%;
  margin-bottom: 1rem;
`;

export const FilesList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  width: 100%;
`;

export const FileItem = styled.div`
  display: grid;
  grid-template-columns: 32px 1fr 40px;
  align-items: center;
  gap: 0.75rem;
  background: ${colors.backgroundHover};
  border-radius: ${radii.md};
  padding: 0.5rem 0.75rem;
  width: 100%;
`;

export const FileIconCustom = styled(FileIcon)`
  width: 24px;
  height: 24px;
`;

export const FileDetails = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
  gap: 0.25rem;
`;

export const FileName = styled.span`
  font-size: 0.875rem;
  font-weight: 500;
  color: ${colors.text};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const FileSize = styled.span`
  font-size: 0.75rem;
  color: ${colors.gray400};
`;

export const DeleteButton = styled.button`
  background-color: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.2s ease;

  &:hover:not(:disabled) {
    transform: scale(1.1);
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

export const DeleteIcon = styled(MdDeleteOutline)`
  height: 1.5rem;
  width: 1.5rem;
  color: ${colors.gray400};

  ${DeleteButton}:hover:not(:disabled) & {
    color: ${colors.red300};
  }
`;
